import { TreatmentPlanResponse } from '@/schema/treatmentPlan';
import Api from './api';

const TreatmentPlanApi = {
  getByScanId(scanId: string) {
    return Api.get<TreatmentPlanResponse>(`/treatment-plans/${scanId}`);
  },

  exists(scanId: string) {
    return Api.get<boolean>(`/treatment-plans/${scanId}/exists`);
  },
};

export default TreatmentPlanApi;
